/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ec33x5SEN4aEEFQbKCmZsX
import { createUseGlobalVariants } from "@plasmicapp/react-web";
import { useScreenVariants as useScreenVariantsesSeBLsAxWt } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EsSeBLs-AxWt/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantsesSeBLsAxWt
});
